import React from "react";
import AppContainer from "components/ui/AppContainer";
import DashboardBranchesTable from "./branchContainer";

const StoreList = ({title = "Stores", subTitle = "Add, Update Stores, You can also OFF store to not accept any online order", footer, ...rest}) => {
  return (
    <AppContainer
      title={title}
      subTitle={subTitle}
      footer={footer}
    >
      <DashboardBranchesTable {...rest} />
    </AppContainer>
  );
};

export default StoreList;
